import script from "./MapFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapFooter.vue?vue&type=script&setup=true&lang=ts"

import "./MapFooter.vue?vue&type=style&index=0&id=38095b1e&lang=less"

const __exports__ = script;

export default __exports__